import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/HomePage.jsx';
import Login from './pages/Log.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import TransactionsPage from './pages/TransactionsPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';
import ChatbotPage from './pages/ChatbotPage.jsx'; // ✅ Only this one!

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/chat" element={<ChatbotPage />} />
      </Routes>
    </Router>
  );
}

export default App;
